import { Reveal, Overline } from "@/components/Reveal";
import { IMAGES } from "@/lib/images";

const STATS = [
  { value: "50+", label: "Community projects launched" },
  { value: "1,200+", label: "Students mentored" },
  { value: "25", label: "Local partners & foundations" },
];

export const Community = () => (
  <section
    id="community"
    data-testid="community-section"
    className="relative py-24 sm:py-32 bg-ink text-parchment grain"
  >
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <Reveal>
          <Overline>Community Initiatives & Impact</Overline>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight">
            Service that shows up — and stays.
          </h2>
          <p className="mt-5 text-base sm:text-lg text-parchment/70 leading-relaxed">
            From youth mentorship to local outreach and revival gatherings, the
            work is rooted in presence: being with people, for the long haul.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5">
        <Reveal className="md:col-span-7" >
          <div className="relative h-72 md:h-full min-h-[300px] rounded-2xl overflow-hidden border border-white/10 group">
            <img
              src={IMAGES.worship}
              alt="Laying on of hands during a revival service"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/20 to-transparent" />
            <div className="absolute bottom-0 p-6">
              <h3 className="font-serif text-2xl font-semibold">Revival Gatherings</h3>
              <p className="text-sm text-parchment/70 mt-1 max-w-md">
                Evenings of worship and renewal that bring neighbors together.
              </p>
            </div>
          </div>
        </Reveal>

        <div className="md:col-span-5 grid grid-cols-1 gap-5">
          <Reveal delay={0.1}>
            <div className="relative h-44 rounded-2xl overflow-hidden border border-white/10 group">
              <img
                src={IMAGES.mentor}
                alt="Graduation and mentorship ceremony"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/90 to-transparent" />
              <div className="absolute bottom-0 p-5">
                <h3 className="font-serif text-xl font-semibold">Youth Mentorship</h3>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="relative h-44 rounded-2xl overflow-hidden border border-white/10 group">
              <img
                src={IMAGES.volunteers}
                alt="Clergy leading a worship service"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/90 to-transparent" />
              <div className="absolute bottom-0 p-5">
                <h3 className="font-serif text-xl font-semibold">Local Outreach</h3>
              </div>
            </div>
          </Reveal>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-5">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.1}>
            <div className="p-7 rounded-2xl border border-white/10 bg-white/[0.03]">
              <div className="font-serif text-4xl font-semibold gold-foil">{s.value}</div>
              <div className="mt-2 text-sm text-parchment/65">{s.label}</div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <figure className="mt-10 max-w-3xl">
          <blockquote className="font-serif text-2xl sm:text-3xl leading-snug italic text-parchment/90">
            “Charles doesn’t just speak about community — he builds it, one
            relationship at a time.”
          </blockquote>
          <figcaption className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-gold-light">
            — Community Partner
          </figcaption>
        </figure>
      </Reveal>
    </div>
  </section>
);
